import CTASection from "../components/CTASection";
import RiskWarning from "../components/RiskWarning";

export default function Disclaimers() {
  return (
    <div id="main-content" className="pt-20" data-testid="disclaimers-page">
      <section className="py-32 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-gray-100" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Disclaimers
          </h1>

          <div className="space-y-8">
            <CTASection />

            <RiskWarning />

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="standard-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Standard Risk Disclaimer</h2>
              <p className="text-gray-400 mb-4">
                Mutual Fund investments are subject to market risks, read all scheme related documents carefully.
              </p>
              <p className="text-gray-400 text-sm">
                This is the standard risk warning mandated by SEBI for all mutual fund communications. No alterations or additions are permitted to this text.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="past-performance-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Past Performance</h2>
              <p className="text-gray-400">
                Past performance is not indicative of future returns. Historical data, performance metrics, and return figures 
                mentioned anywhere on this website are for illustrative purposes only and should not be construed as a promise 
                or guarantee of future results.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="educational-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Educational Content</h2>
              <p className="text-gray-400">
                All information provided on this website is for educational and informational purposes only. It does not constitute 
                investment advice, financial planning, or any form of recommendation to buy, sell, or hold any financial instrument.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="distributor-role-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Distributor Role</h2>
              <p className="text-gray-400 mb-4">
                Kredere Family Office Private Limited is registered with AMFI as a mutual fund distributor and SIF distributor. 
                We do not provide investment advisory services unless separately registered for such activities.
              </p>
              <p className="text-gray-400">
                Our role is limited to the distribution of mutual fund and SIF products. All investment decisions remain solely 
                with the investor after due consideration of risks and objectives.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="accuracy-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Information Accuracy</h2>
              <p className="text-gray-400">
                While we strive to ensure the accuracy of information presented on this website, we do not warrant or guarantee 
                its completeness, reliability, or timeliness. Information may change without notice.
              </p>
              <p className="text-gray-400 mt-4">
                For the most current and accurate product information, please refer to official documents provided by the respective 
                Asset Management Companies.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="liability-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Limitation of Liability</h2>
              <p className="text-gray-400">
                Kredere Family Office Private Limited shall not be liable for any direct, indirect, incidental, consequential, 
                or punitive damages arising from the use of this website or any information contained herein.
              </p>
            </div>

            <div className="p-6 bg-[#0f0f0f] border border-gray-800 rounded-lg" data-testid="third-party-disclaimer">
              <h2 className="text-2xl font-semibold mb-4 text-[#d4af69]">Third-Party Content</h2>
              <p className="text-gray-400">
                This website may contain links to third-party websites or references to third-party content. We do not endorse 
                or assume responsibility for the content, accuracy, or practices of third-party sites.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}